export default "__VITE_ASSET__$ujNvq0i__"